module.exports = __webpack_public_path__ + "img/amxmodules.494c91d5.jpg";